/**
 * SearchLogData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { SearchLog } from './search_log'

/**
 * SearchLogData
 */
export interface SearchLogData {
  /** 搜索日志ID */
  id?: string
  /** 搜索日志信息 */
  info?: SearchLog
}

/**
 * SearchLogData Schema
 */
export const SearchLogDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '搜索日志ID',
      format: 'string',
      type: 'string',
      label: '搜索日志ID',
    },
    info: {
      $ref: 'SearchLog',
      description: '搜索日志信息',
      label: '搜索日志信息',
    },
  },
  type: 'object',
}
